import axios from 'axios';
import {
    CheckInQuestion,
    CheckInQuestionResult
} from '../models/check-in-question';

export const getCheckInQuestions = async (appointmentId: number): Promise<Undefinable<CheckInQuestion[]>> => {
    const response = await axios.get(`/api/check-in-question/appointment/${appointmentId}`);
    return response.data;
};

export const createCheckInQuestion = async (checkInQuestion: CheckInQuestion): Promise<CheckInQuestionResult> => {
    const response = await axios.post(`/api/check-in-question`, checkInQuestion);
    return response.data;
};

export const updateCheckInQuestion = async (checkInQuestion: CheckInQuestion): Promise<CheckInQuestionResult> => {
    const response = await axios.put(`/api/check-in-question`, checkInQuestion);
    return response.data;
};
